import { Group, Stack } from '@mantine/core'
import React from 'react'
import ReportElement from './ReportElement'
import { ThemeConfig } from '../../utils/themeConfig'

interface ReportElementsProps {
  modules?: string[]
  themeConfig: ThemeConfig
}

export default function ReportElements({ modules, themeConfig }: ReportElementsProps) {
  if (!modules || modules.length === 0) return null

  return (
    <div className="bg-white rounded-xl p-4 lg:p-5 shadow-sm">
      <Stack gap="md">
        <div className={'text-left text-base lg:text-lg font-bold'}>报告主要内容</div>
        <Group gap="xs" className="flex-wrap">
          {modules?.map((module, index) => <ReportElement key={index} name={module} themeConfig={themeConfig} />)}
        </Group>
      </Stack>
    </div>
  )
}
